import { useEffect, useRef } from "react";

const PUBLISHER_ID = "ca-pub-8312219976960245";

export default function Adsense({
  slot,
  format = "auto",
  responsive = true,
  style = { display: "block" },
  className,
  layout,
  layoutKey,
}) {
  const adRef = useRef(null);

  useEffect(() => {
    if (!adRef.current || typeof window === "undefined") {
      return;
    }

    if (adRef.current.dataset.adsbygoogleLoaded === "true") {
      return;
    }

    try {
      window.adsbygoogle = window.adsbygoogle || [];
      window.adsbygoogle.push({});
      adRef.current.dataset.adsbygoogleLoaded = "true";
    } catch (error) {
      console.warn("Adsense failed to initialize", error);
    }
  }, []);

  return (
    <ins
      ref={adRef}
      className={`adsbygoogle${className ? ` ${className}` : ""}`}
      style={style}
      data-ad-client={PUBLISHER_ID}
      data-ad-slot={slot}
      data-ad-format={format}
      data-full-width-responsive={responsive ? "true" : "false"}
      data-ad-layout={layout}
      data-ad-layout-key={layoutKey}
    />
  );
}
